import { Pipe, PipeTransform } from '@angular/core';
import { ClientTranslationKeyModel, LocaleModel } from '../models/language-locale.model';
import { TranslationTextSearchOption } from '../models/translation-text-search-options.model';

@Pipe({
	name: 'translationTextSearch',
	standalone: true
})
export class TranslationTextSearchPipe implements PipeTransform {
	transform(
		clientTranslationKeys: ClientTranslationKeyModel[],
		searchText: string,
		searchType: TranslationTextSearchOption
	): ClientTranslationKeyModel[] {
		if (!clientTranslationKeys || !searchType || !searchText) {
			return clientTranslationKeys;
		}
		// filter items array, items which match and return true will be kept, false will be filtered out
		return clientTranslationKeys.filter((key: ClientTranslationKeyModel) => {
			if (searchType == 'Key') {
				if (key.key.toLowerCase().includes(searchText.toLowerCase())) {
					return true;
				} else {
					return false;
				}
			} else if (searchType == 'Translated Text') {
				const matched = key.languages.filter((language: LocaleModel) => {
					if (language.translatedText.toLowerCase().includes(searchText.toLowerCase())) {
						return true;
					} else {
						return false;
					}
				});

				if (matched.length != 0) {
					return true;
				}

				return false;
			} else if (searchType == 'Portal Page Name') {
				if (key.portalPageName != null) {
					const matched = key.portalPageName.filter((pageName: string) => {
						if (pageName.toLowerCase().includes(searchText)) {
							return true;
						} else {
							return false;
						}
					});

					if (matched.length != 0) {
						return true;
					}
				}
				return false;
			}
			return false;
		});
	}
}
